// Utilities
import axios from "axios";

const state = {
  obj: "working",
  new_document_object: {},
  error: "",

  margin: null,
};

const mutations = {
  SET_NEW_DOCUMENT(state, payload) {
    state.new_document_object = payload;
  },
  Auth_error(state, payload) {
    state.error = "Ce numéro de document n'existe pas";
  },
};

const actions = {
  getProjects({ commit }, Infos) {
    const datacollect = {
      category: Infos.category,
      page: Infos.page,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: "/api/3VLKE82QP27YT6DO423D/getProjects",
        method: "POST",
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteProject({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: "/api/3VLKE82QP27YT6DO423D/deleteProject",
        method: "POST",
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteProjectImage({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
      imageId: Infos.imageId,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: "/api/3VLKE82QP27YT6DO423D/deleteProjectImage",
        method: "POST",
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateProject({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: "/api/3VLKE82QP27YT6DO423D/updateProject",
        method: "POST",
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchProject({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
      category: Infos.category,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: "/api/3VLKE82QP27YT6DO423D/searchProject",
        method: "POST",
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // Publications

  getPublication({ commit }, Infos) {
    const datacollect = {
      page: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: "/api/ENH5ZL4T64ZK88EH4RGZ/getPublication",
        method: "POST",
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchPublication({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: "/api/ENH5ZL4T64ZK88EH4RGZ/searchPublication",
        method: "POST",
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
